<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-12">
              <h1>
                IPSEC Transport Status
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">IPSEC Transport Status</li>
              </ol>
            </div>
          </div>
        </div>
        <!-- /.container-fluid -->
      </section>

      <section class="content" v-if="has_permission === true">
        <div class="container-fluid">
          <div class="card">
            <div
              class="card-header"
              v-if="!_.isEmpty(list.data) && is_loading == false"
            >
              <div class="btn-toolbar pull-right">
                <!-- <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                  <i class="fa fa-filter"></i> Filter
                </button> -->
              </div>
  
              <!-- <div class="card-tools">
                <button class="btn btn-outline" @click="exportFile()">
                  <i class="icon-download"></i> Export
                </button>
              </div> -->
            </div>
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>

            <div class="card-body">
              <div v-if="!_.isEmpty(list.data) && is_loading == false">
                <div class="table-responsive-md">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="column-source_address">Audra</th>
                        <th class="column-source_address">Profile</th>
                        <th class="column-source_address">Gateway</th>
                        <th class="column-duration">Status</th>
                        <th class="column-frequency">Action</th>
                      </tr>
                    </thead>
                    <tbody class="list">
                      <tr v-for="(val, index) in list.data">

                        <td>{{ val.device_name }}</td>
                        <td>{{ val.ipsec_profile_name }}</td>
                        <td>{{ val.vti_remote_ip }}</td>
                        <td>{{ statusLabel[index] }}</td>
                        <td
                          @click="changeIpSecTransportStatus(val, index)"
                          style="font-weight: bold; cursor: pointer"
                        >
                          {{ val.ipsec_is_active ? 'Discon' : 'Conn' }}
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
                <div class="no-data">
                  <img src="/assets/images/no-data.svg" alt="" />
                  <h3>No data found!</h3>
                </div>
              </div>
            </div>

            <div :class="{ 'card-footer': list.total > list.per_page }">
              <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload()"
              ></vue-pagination>
            </div>
          </div>
        </div>
      </section>

      <section class="content" v-if="has_permission === false">
        <div class="alert alert-danger alert-dismissible">
          <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
        </div>
      </section>
    </div>
  </template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "IPSECTransportStatus",
  metaInfo: {
    title: "IPSEC Transport Status | Dotlines",
  },
  components: {
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: [],
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    statusLabel: [],
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/ipsec-status";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      await CommonAPI.getCustomPermission(
        "/get-custom-permission-infos?path=api/router-status"
      ).then((response) => {
        if (response.status == 200) {
          this.custom_permission_data = response.data;
        }
      });

      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["create_id_condition"],
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      }

      await this.getList()
        .then((response) => {
          this.list = response.data;
          this.setStatusLabel()
        })
        .catch((error) => {
          this.empty = true;
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error)
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get('/ipsec-transport-status', {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
  
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index) {
      const _this = this;
      const delete_api_url = "/pbr_mapping/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/pbr-mapping-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "pbr_mapping.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },

    changeIpSecTransportStatus (val, index) {
      const vpnLink = '/changeIpSecTunnelTransportStatus'

      const _this = this

      this.statusLabel[index] = val.ipsec_is_active
        ? 'Disconnecting..'
        : 'Connecting..'
      this.$forceUpdate()
      const ipSecStatus = val.ipsec_is_active == 0 ? 'connect' : 'disconnect'
      axios({
        method: 'POST',
        url: vpnLink,
        data: {
          accountId: val.accountId,
          profilename: val.ipsec_profile_name,
          status: ipSecStatus
        },
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (response) {
          if (val.ipsec_is_active != 0) {
            setTimeout(() => {
              _this.disConnectTransport(
                val.id,
                val.ap_wi_mac,
                ipSecStatus,
                index
              )
            }, 5000)
          } else {
            let countConnectionCheck = 0
            const connection = setInterval(function () {
              _this.checkConnectionStatus(
                val.id,
                val.ap_wi_mac,
                index,
                countConnectionCheck,
                connection
              )

              if (countConnectionCheck++ >= 30) {
                clearInterval(connection)
              }
            }, 1000)
          }

          // _this.$toaster.success(response.data.message)
        })
        .catch(errors => {
          _this.statusLabel[index] = val.ipsec_is_active
            ? 'Connected'
            : 'Disconnected'
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message)
            _this.$setErrorsFromResponse(errors.response.data.errors)
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message)
            _this.$setErrorsFromResponse(errors.response.data)
          }
        })
        .finally(() => {
          // _this.is_loading = false
          this.$forceUpdate()
        })
    },

    disConnectTransport (id, ap_wi_mac, status, index) {
      const _this = this
      axios({
        method: 'post',
        url: '/updateIpsecTunnelTransportStatus',
        data: {
          id: id,
          ap_wi_mac: ap_wi_mac,
          status: status,
          accountId: localStorage.get('accountId')
        },
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function () {
          _this.list.data[index].ipsec_is_active = 0
          _this.statusLabel[index] = 'Disconnected'
        })
        .catch(errors => {
          _this.statusLabel[index] = 'Connected'
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message)
          }
          _this.$setErrorsFromResponse(errors.response.data)
        })
        .finally(() => {
          _this.$forceUpdate()
          _this.is_loading = false
        })
    },

    checkConnectionStatus (
      id,
      ap_wi_mac,
      index,
      countConnectionCheck,
      connection
    ) {
      let isConnected = 0
      const _this = this
      axios({
        method: 'post',
        url: '/checkTunnelIpSecTransportStatus',
        data: {
          id: id,
          ap_wi_mac: ap_wi_mac,
          accountId: localStorage.get('accountId')
        },
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (response) {
          if (response.data == '1') {
            isConnected = 1
            clearInterval(connection)
          }
        })
        .catch(errors => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.message)
          }
          _this.$setErrorsFromResponse(errors.response.data)
        })
        .finally(() => {
          if (countConnectionCheck >= 30 || isConnected == 1) {
            if (isConnected == 1) {
              _this.list.data[index].ipsec_is_active = 1
              _this.statusLabel[index] = 'Connected'
            } else {
              _this.statusLabel[index] = 'Disconnected'
            }
            _this.$forceUpdate()
          }
          _this.is_loading = false
        })
    },

    setStatusLabel () {
      for (let i = 0; i < this.list.data.length; i++) {
        this.statusLabel[i] = !this.list.data[i]
          .ipsec_is_active
          ? 'Disconnected'
          : 'Connected'
      }
    },
  },
};
</script>
